import axiosPost from "./axiosPost";

export const RNHHospitalIns = async (credentials, data) => {
    const body = {
        service: "RNHHospitalIns",
        params: {
            rnhHospitalCod: data?.cod,
            rnhHospitalNombre: data?.name,
            rnhNivelId: data?.nivelId,
            rnhAreaId: data?.areaId,
            rnhHospitalCabecera: data?.cabecera,
            rnhHospitalCalle: data?.calle,
            rnhHospitalNumero: data?.numero,
            rnhHospitalPiso: data?.piso,
            rnhUnidadId: data?.unidad,
            localidadId: data?.localidadId,
            rnhHospitalLatitud: data?.lat,
            rnhHospitalLongitud: data?.lng
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
